import React from "react";
import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Outlet, Link } from "react-router-dom";

export default function NavbarComponent({
    title = "Set title here",
    nav1 = "nav 1",
    nav2 = "Nav 2",
}) {
    return (
        <>
            <Navbar
                bg="light"
                data-bs-theme="light"
                sticky="top"
                className="navbar bg-body-tertiary"
            >
                <Container>
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to={"/"}>
                            <div className="navText">{title}</div>
                        </Nav.Link>
                        <Nav.Link as={Link} to={"/" + nav1}>
                            <div className="navText">{nav1}</div>
                        </Nav.Link>
                        <Nav.Link as={Link} to={"/" + nav2}>
                            <div className="navText">{nav2}</div>
                        </Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
            <Outlet />
        </>
    );
}

NavbarComponent.propTypes = {
    title: PropTypes.string.isRequired,
    nav1: PropTypes.string.isRequired,
    nav2: PropTypes.string.isRequired,
};
